import api from '@/store/api/bundle'
import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'

// Modules
import bundle from './bundle'

const initialState = () => ({
    bundles: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    modules: {
        bundle
    },
    getters: {
        bundles: state => state.bundles.data,
        pagination: state => state.bundles.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listBundles: async ({ commit, dispatch}, params) => {
            try {
                const response = await api.listBundles(params)
                const bundles = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_BUNDLES, bundles)

                return bundles
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBundles: ({commit}) => commit(mutationTypes.RESET_BUNDLES)
    },
    mutations: {
        [mutationTypes.RESET_BUNDLES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_BUNDLES]: (state, data) => state.bundles = data
    }
}
